import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AggregatedScenarioResultIcon,
  AnalyticsSandboxIcon,
  AnalyticsSandboxMetadataIcon,
  CalculatorIcon,
  CheckCircleIcon,
  DealTermIcon,
  EscalatedForwardCurveAsOfDateIcon,
  EscalatedForwardCurveReferenceIcon,
  ExecuteValuationTaskIcon,
  ForwardCurveReferenceIcon,
  ForwardCurveRevisionIcon,
  ImportIcon,
  ModelCalibrationIcon,
  ModelResultIcon,
  ShieldExclamationIcon,
  TimeSeriesAnalyticalSandboxDataPurgeIcon,
  TimeSeriesIcon,
  ValuationRunResultsIcon,
  ValuationTaskIcon,
  VolatilityReferenceIcon,
  XCircleIcon,
  HistoricDatasetIcon,
  CircleIconProcessing,
  TableCellsIcon,
  PPAAssetIcon,
  PPABusinessPartnerIcon,
  PPADefaultIcon,
  PPAGenerationUnitIcon,
  PPAMaLoIcon,
  PPADealIcon,
  PPATransactionIcon,
  PPAContractIcon,
  PPAMarketParticipantIcon,
  TabNavLinkIcon,
  PPADealGroupIcon,
  PPAInventoryTimeSeriesIcon,
  PPAAddIcon
} from './icons.component';
import { RouterModule } from '@angular/router';
import { ManagePPATimeseriesComponentModule } from 'src/app/pages/ppa-inventory/components/manage-ppa-objects/components/manage-ppa-timeseries/manage-ppa-timeseries.component.module';

const declarationsAndExports = [
  DealTermIcon,
  TimeSeriesIcon,
  AnalyticsSandboxIcon,
  AnalyticsSandboxMetadataIcon,
  ModelCalibrationIcon,
  VolatilityReferenceIcon,
  ForwardCurveReferenceIcon,
  PPAInventoryTimeSeriesIcon,
  PPAAssetIcon,
  PPABusinessPartnerIcon,
  PPAContractIcon,
  PPAMarketParticipantIcon,
  PPADealGroupIcon,
  PPADefaultIcon,
  TabNavLinkIcon,
  PPAAddIcon,
  PPAMaLoIcon,
  PPADealIcon,
  PPAGenerationUnitIcon,
  PPATransactionIcon,
  ValuationTaskIcon,
  ExecuteValuationTaskIcon,
  ModelResultIcon,
  ValuationRunResultsIcon,
  ForwardCurveRevisionIcon,
  TimeSeriesAnalyticalSandboxDataPurgeIcon,
  EscalatedForwardCurveReferenceIcon,
  EscalatedForwardCurveAsOfDateIcon,
  ImportIcon,
  CheckCircleIcon,
  XCircleIcon,
  AggregatedScenarioResultIcon,
  ShieldExclamationIcon,
  CalculatorIcon,
  HistoricDatasetIcon,
  CircleIconProcessing,
  TableCellsIcon,
];

@NgModule({
  declarations: [...declarationsAndExports],
  exports: [...declarationsAndExports],
  imports: [CommonModule, RouterModule],
})
export class IconsModule {}
